export default __webpack_public_path__ + "static/media/Promo2.91e23472.jpeg";